import { render, staticRenderFns } from "./commissionDetails.vue?vue&type=template&id=123bd601&"
import script from "./commissionDetails.vue?vue&type=script&lang=js&"
export * from "./commissionDetails.vue?vue&type=script&lang=js&"
import style0 from "./commissionDetails.vue?vue&type=style&index=0&id=123bd601&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports